/** Generic rotating composer copy shared by Home and Ask Circadia AI. */
export const GENERAL_CHAT_PLACEHOLDERS = [
  "How can we help you today?",
  "Enable workflows to automate routine tasks",
  "Explore Neo's predefined templates",
  "Ask Neo about patients, flags, and clinical trends",
] as const;

/** Predict-page questions used when the chat is not scoped to one flag. */
export const PREDICT_CHAT_STARTERS = [
  "Which flagged patients should I review first?",
  "Summarize today’s flags for my team",
  "Who has been flagged more than once this week?",
] as const;

/** General questions used by the Ask Circadia AI landing state. */
export const GENERAL_CHAT_STARTERS = [
  "What changed with my patients overnight?",
  "Who is at highest risk of a hospital transfer?",
  "Draft a shift handoff summary",
] as const;
